import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./redux";
import { AppAuthWrapper } from "./AppAuthWrapper";


ReactDOM.render(

  <Provider store={store}>  
    <AppAuthWrapper includeAuth0={window['auth0Config'].USE_AUTH_0} />       
  </Provider>
  
  ,
   document.getElementById("root")
);
